'use client'

import { CodeSnippet } from '@circlefin/components/lib/CodeSnippet'

export const CWCodeSnippet = CodeSnippet
export const CWCodeSnippetControls = CodeSnippet.Controls
export const CWCodeSnippetControlsCopy = CodeSnippet.Controls.Copy
